import { FadeUp, MaskedLines } from '../components/anim';
import { CONTACT } from '../data/portfolio';

export default function Contact() {
  return (
    <main data-testid="contact-page" className="px-6 pt-28 md:px-10 md:pt-40">
      <div className="mx-auto max-w-[1600px]">
        <MaskedLines
          lines={[
            <h1 key="c" data-testid="contact-heading" className="text-[clamp(34px,4.2vw,60px)] font-light uppercase tracking-[0.14em] text-balance">
              Contact
            </h1>,
          ]}
        />
        <div className="mt-10 h-px bg-ink/25" />

        <div className="py-24 pb-28 md:py-32 md:pb-40">
          <FadeUp>
            <div data-testid="contact-phrase" className="text-xl font-normal uppercase tracking-[0.12em] text-balance md:text-3xl">
              Let’s design your space
            </div>
            <div className="mt-8 space-y-2 text-xs uppercase tracking-[0.25em] text-ink/80">
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="contact-email"
                className="block transition-colors hover:text-ink/60"
              >
                Email : donatiengrimaud@gmail.com
              </a>
              <a
                href="tel:+33684827754"
                data-testid="contact-tel"
                className="block transition-colors hover:text-ink/60"
              >
                Tel : +33 (6) 84 82 77 54
              </a>
            </div>
          </FadeUp>
        </div>
      </div>
    </main>
  );
}
